import tippy from 'tippy.js';

tippy.setDefaultProps({ maxWidth: '' });

tippy('.with-resource-card .thumbnail', {
    content(reference) {
        const template = reference.closest('.with-resource-card').nextElementSibling;
        return template ? template.innerHTML : '';
    },
    animation: 'scale-subtle',
    arrow: false,
    allowHTML: true,
    inertia: true,
    placement: 'top',
    popperOptions: {
        modifiers: [{
            name: 'flip',
            enabled: false,
        },
        {
            name: 'offset',
            options: {
                offset: ({ reference, popper }) => {
                    const referenceHeight = reference.height;
                    const popperHeight = popper.height;
                    const offsetY = -(referenceHeight / 2 + popperHeight / 2);
                    return [0, offsetY];
                },
            },
        },
        ],
    },
    touch: false,
    theme: 'idello',
    onShow(instance) {
        const currentSlide = instance.reference.closest('.swiper-slide');
        if (currentSlide) {
            if (currentSlide.classList.contains('swiper-slide-fully-visible')) {
                return true;
            }
        } else {
            return true;
        }
        return false;
    },
});

tippy('.has-tooltip', {
    arrow: false,
    maxWidth: 190,
    theme: 'blue',
});
